import { IPhoneNumber, IPhoneNumberGroup } from '../interface'
import { NumberItem } from './NumberItem'

export const NumberGroup = ({
   group,
   onAssign = undefined,
   showAssignButton = false,
   showMessageCount = true,
   children = null,
   selectMode = false,
   onSelect = () => {},
   selectedNumbers = [],
      onDelete = undefined,
   checkboxMode = false,
   onCheckboxChange = undefined,
   anyItemChecked = false,
}: {
   group: IPhoneNumberGroup
   onAssign?: (number: IPhoneNumber) => void
   showAssignButton?: boolean
   showMessageCount?: boolean
   children?: React.ReactNode
   selectMode?: boolean
   onSelect?: (number: IPhoneNumber) => void
   selectedNumbers?: IPhoneNumber[] | Set<string>
   onDelete?: (number: IPhoneNumber) => void
   checkboxMode?: boolean
   onCheckboxChange?: (number: IPhoneNumber) => void
   anyItemChecked?: boolean
}) => {
   return (
      <div className="flex flex-col gap-y-2">
         <div className="flex items-center justify-between px-8">
            <div className="flex items-center gap-x-2">
               <p className="text-white text-sm font-medium">
                  {group.areaCode}
               </p>
               <p className="text-white/70 text-sm font-medium">
                  {group.locality}
               </p>
            </div>

            <p className="text-white/70 text-sm font-medium">
               {group.count} Numbers
            </p>
         </div>
         <div className="flex flex-col gap-y-2">
            {group.numbers.map((number, index) => {
               const isSelected = Array.isArray(selectedNumbers)
                  ? selectedNumbers.some(
                       (selectedNumber) =>
                          selectedNumber.phoneNumber.phoneNumber ===
                          number.phoneNumber.phoneNumber
                    )
                  : false
               const isChecked =
                  selectedNumbers instanceof Set
                     ? selectedNumbers.has(number.phoneNumber.phoneNumber)
                     : false

               return (
                  <NumberItem
                     key={index}
                     onSelect={onSelect}
                     onAssign={onAssign}
                     number={number}
                     showAssignButton={showAssignButton}
                     showMessageCount={showMessageCount}
                     selectMode={selectMode}
                     isSelected={isSelected}
                     onDelete={onDelete}
                     checkboxMode={checkboxMode}
                     isChecked={isChecked}
                     onCheckboxChange={onCheckboxChange}
                     anyItemChecked={anyItemChecked}
                  >
                     {children}
                  </NumberItem>
               )
            })}
         </div>
      </div>
   )
}
